import { postData, getData } from "../baseApi";
import { jsonToForm } from "../utils";

const PAYMENT_API = {
  CHECK_TICKET: "/payment/get_ticket_usable/",
  GET_BUYABLE: "/payment/get_ticket_buyable/",
  USE_TICKET: "/payment/use_ticket/",
  CREATE_ORDER: "/payment/create_order_book/",
};

/** 보유 티켓 확인 */
export const checkTicket = (serviceName) => {
  return getData(PAYMENT_API.CHECK_TICKET, { service_name: serviceName });
};

/** 구매 가능 상품 목록 */
export const getBuyableTickets = (serviceName) => {
  return getData(PAYMENT_API.GET_BUYABLE, { service_name: serviceName });
};

/** 티켓 사용 (차감) */
export const useTicket = (serviceName, target) => {
  const form = jsonToForm({
    service_name: serviceName,
    target: typeof target === "string" ? target : JSON.stringify(target),
  });
  return postData(PAYMENT_API.USE_TICKET, form);
};

/** 주문서 생성 */
export const createOrder = (productKey, quantity = 1, attrs = {}) => {
  const form = jsonToForm({
    product: productKey,
    quantity,
    attrs: JSON.stringify(attrs),
  });
  return postData(PAYMENT_API.CREATE_ORDER, form);
};
